import { render, staticRenderFns } from "./officeItemData.vue?vue&type=template&id=2616f0b6&scoped=true&"
import script from "./officeItemData.vue?vue&type=script&lang=js&"
export * from "./officeItemData.vue?vue&type=script&lang=js&"
import style0 from "./officeItemData.vue?vue&type=style&index=0&id=2616f0b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2616f0b6",
  null
  
)

export default component.exports